export default "__VITE_ASSET__D_Ex0iRe__"